import { RootState } from 'src/redux/store';
import { TCanaryNetworkState } from 'src/redux/canaryNetwork/canaryNetwork.slice';

export const selectCanaryNetworkUsers = (state: RootState): TCanaryNetworkState['users'] =>
  state.canaryNetwork.users;

export const selectCanaryNetworkAllHomes = (state: RootState): TCanaryNetworkState['assets'] =>
  state.canaryNetwork.assets;
